module.exports = __webpack_public_path__ + "static/media/array-desktop.03a7ce49.png";